var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMail = function SvgMail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 14 14"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.4,
    d: "m1.167 4.083 3.03 2.02c.174.117.262.175.356.216q.127.055.262.08c.102.018.207.018.417.018h3.536c.21 0 .315 0 .417-.018q.136-.025.262-.08c.094-.041.182-.1.357-.216l3.03-2.02m-8.867 7.584h6.066c.98 0 1.47 0 1.845-.191a1.75 1.75 0 0 0 .765-.765c.19-.374.19-.864.19-1.844V5.133c0-.98 0-1.47-.19-1.844a1.75 1.75 0 0 0-.765-.765c-.374-.19-.865-.19-1.845-.19H3.967c-.98 0-1.47 0-1.845.19a1.75 1.75 0 0 0-.765.765c-.19.374-.19.864-.19 1.844v3.734c0 .98 0 1.47.19 1.844.168.33.436.597.765.765.375.19.865.19 1.845.19"
  })));
};
export default SvgMail;